/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { bulkContactResultsResponseDtoSchema } from "../bulkContactResultsResponseDtoSchema";
import { bulkSetContactMonitoringDtoSchema } from "../bulkSetContactMonitoringDtoSchema";
import { z } from "zod/v4";

export const setContactsMonitoringHeaderParamsSchema = z.object({
    "x-tenant-id": z.optional(z.string().describe("Required tenant context header for tenant-scoped endpoints guarded by ApiGuard."))
    }).optional()

/**
 * @description Turns monitoring on or off for up to 1,000 contacts. Each contact is updated independently, so a missing or failing one does not affect the others; the response has one result per distinct contact ID.
 */
export const setContactsMonitoring200Schema = z.lazy(() => bulkContactResultsResponseDtoSchema)

/**
 * @description Missing tenant context or invalid x-api-key header for guarded endpoints.
 */
export const setContactsMonitoring401Schema = z.any()

export const setContactsMonitoringMutationRequestSchema = z.lazy(() => bulkSetContactMonitoringDtoSchema)

export const setContactsMonitoringMutationResponseSchema = z.lazy(() => setContactsMonitoring200Schema)